module.exports = __webpack_public_path__ + "img/clover-check-mark.ac6ca5f9.svg";